<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/site/css/open-iconic-bootstrap.min.css";
// import "@/assets/site/css/style.css";
import "@/assets/site/fontawesome-free/css/all.min.css";
import "@/assets/adminlte/css/adminlte.css";

export default {
  name: "App",
};
</script>